import React from 'react';
import { ToggleButton, ToggleButtonGroup, Box } from '@mui/material';
import { styled } from '@mui/system';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  borderRadius: '50px',
  borderWidth: '1px',
  boxShadow: '0px 1px 5px rgba(0,0,0,0.10)',
  overflow: 'hidden',
  transition: 'box-shadow 0.3s ease-in-out',
}));

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  flex: 1,
  height: '40px',
  width: '120px',
  fontWeight: 'initial',
  color: '#000',
  transition: 'background-color 0.3s ease-in-out, color 0.3s ease-in-out',
  '&.Mui-selected': {
    backgroundColor: '#32CA73',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#32CA73',
    },
  },
  '&:not(.Mui-selected)': {
    backgroundColor: '#fff',
    color: '#000',
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
}));

function MonthlyYearlyToggle({ view, onToggle }) {
  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      onToggle(newView);
    }
  };

  return (
    <Box display="flex" alignSelf="center"  mt={1}>
      <StyledToggleButtonGroup value={view} exclusive onChange={handleViewChange} aria-label="view toggle">
        <StyledToggleButton value="weekly" aria-label="weekly view">
          Weekly
        </StyledToggleButton>
        <StyledToggleButton value="monthly" aria-label="monthly view">
          Monthly
        </StyledToggleButton>
      </StyledToggleButtonGroup>
    </Box>
  );
}

export default MonthlyYearlyToggle;
